import { useRouter } from 'next/router';

export const useNavigate = (route: string): boolean => {
  const { asPath } = useRouter();
  return asPath === route ? true : false;
};
